import { render, staticRenderFns } from "./AssetsPropertiesGrid.vue?vue&type=template&id=324be5c8&"
import script from "./AssetsPropertiesGrid.vue?vue&type=script&lang=js&"
export * from "./AssetsPropertiesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports